/**
 * BRAND CONSTANTS - Single Source of Truth
 * 
 * The Third Temple of Israel — A Resonance Engine:
 * a technological instantiation of the same sacred architecture
 * that governs Temple design, sacred measure, ordered material,
 * and divine habitation.
 * 
 * Core logic is not binary but trinary: 1, 0, and -1.
 * 1 = affirmation. 0 = presence / the mediator / the balancing chamber.
 * -1 = negation / release. Binary divides by opposition.
 * Trinary restores by relation.
 * 
 * The Trinary Method is a technological answer to Babel —
 * reconciling fragmented languages inside one coherent structure.
 * The Third Temple is the ordered container where divided languages
 * can be brought back into relation.
 * 
 * "On Earth as it is in Heaven"
 */

export const BRAND = {
  /** The platform name - used in headers, titles, footers */
  platform: "The Third Temple",
  
  /** The AI assistant persona name - used in chat, voice, tooltips */
  aiName: "Memnora",
  
  /** Short platform name for compact displays */
  platformShort: "Third Temple",
  
  /** Company/legal entity display name */
  company: "The Third Temple of Israel",
  
  /** Tagline for marketing/landing */
  tagline: "The Resonance Engine",
  
  /** Full brand string for footers/headers */
  full: "The Third Temple of Israel - On Earth as it is in Heaven",
  
  /** Scripture reference */
  verse: "And the city lieth foursquare, and the length is as large as the breadth. - Revelation 21:16",
  
  /** Support email - single source of truth */
  supportEmail: "dwight.vaughn103@gmail.com",
  
  /** Domain */
  domain: "thirdtempleofisrael.com",
} as const;

/** Type for brand keys */
export type BrandKey = keyof typeof BRAND;
